export const getProductPath = (itemId: string, locationPath: string, userAgent: string) => {
    const catalogPathNameCheckRegex = new RegExp(/\/brand\/[a-zA-Z0-9]+\/(linesheet|list)\/[a-zA-Z0-9]+/);

    // If iOS, go to product page, else show side panel
    const pathname =
        /iPad|iPhone|iPod/.test(userAgent) && !locationPath.match(catalogPathNameCheckRegex)
            ? locationPath.split("/").slice(0, 3).join("/")
            : locationPath.replace(/\/$/, "");

    const matcher = /item\/.+/;
    return matcher.test(pathname) ? pathname.replace(matcher, `item/${itemId}`) : `${pathname}/item/${itemId}`;
};
